/**
 * Canonical keyboard-focus ring (see .claude/style-guide.md).
 * Single source of truth — import this instead of declaring a local
 * focusStyle; the per-file copies drifted into three variants before
 * it was centralized.
 */
export const focusStyle =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-light focus-visible:ring-offset-2';
